import {createSelector} from 'reselect'
import * as app from '../../application.selectors';
import { Complete } from '../record/record.status';

// selectors.js
export const currentPeriod = createSelector(
  state => state.sample.entities.periods,
  state => state.sample.selectedPeriod,
  app.userFacility,
  (periods, id, userFacility) => {
    if (!periods[id]) {
      return {dueDate: ''};
    } else {  
      const period = periods[id];
     
      const facilityStatus = (period.facilityStatusesData) ? period.facilityStatusesData.find(s => s.nursingFacilityId === userFacility.id && s.periodId === id) : null;

      return {...periods[id], facilityStatus: facilityStatus ? facilityStatus.status : ''};
    }
  }
);

export const dataJustUploaded = createSelector(
  state => state.sample.uploaded,
  x => x
);

export const filters = createSelector(
  state => state.sample.filters,
  filters => filters
);

export const facilityFilter = createSelector(
  filters,
  filters => filters.facility
);

const removedPatientIds = createSelector(
  state => state.sample.removedPatientIds,
  ids => ids
);

const patientOrder = (a, b) =>
  a.name < b.name ? -1 :
    a.name === b.name ? 0 :
      1;

const patients = createSelector(
  state => state.sample.entities.patients,
  state => state.application.entities.reviewers,
  (patients, reviewers) =>
    Object.keys(patients).map(id => ({
        ...patients[id],
        // reviewer: reviewers[patients[id].reviewer] || {}
      }
    )).sort(patientOrder)
);

export const facilities = createSelector(
  patients,
  state => state.application.entities.facilities,
  (patients, facilities) => {
    const patientFacilityIds = Array.from(new Set(patients.map(x => x.facilityId)));
    return Object.keys(facilities)
      .filter(id => patientFacilityIds.includes(id))
      .map(id => facilities[id]);
  }
);

const patientFilter = (patient, {facility, reviewer, recordStatus}) => {
  const byFacility = facilityId => facilityId ? patient.facilityId === facilityId : true;
  const byReviewer = reviewer => reviewer ? patient.reviewer === reviewer : true;
  const byRecordStatus = recordStatus => recordStatus ? patient.recordStatus === recordStatus : true;

  return byFacility(facility) && byReviewer(reviewer) && byRecordStatus(recordStatus)
};

export const includedPatients = createSelector(
  currentPeriod, patients, removedPatientIds, filters,
  (period, patients, removedIds, filters) => patients
    .filter(({id}) => !removedIds.includes(id))
    .filter(x => patientFilter(x, filters))
);

export const removedPatients = createSelector(
  currentPeriod, patients, removedPatientIds, filters,
  (period, patients, removedIds, filters) => patients
    .filter(({id}) => removedIds.includes(id))
    .filter(x => patientFilter(x, filters))
);

// noinspection JSUnusedGlobalSymbols
export const allReviewers = createSelector(
  patients,
  (patients) => Array.from(
    new Set(patients.map(x => x.reviewer))
  ).filter(x => !!x).sort()
);

export const reviewersWithRecords = createSelector(
  patients,
  (patients) => patients.filter(x => !!x.reviewer && x.recordStatus == Complete).map(x => x.reviewer).sort()
);

export const allRecordStatus = createSelector(
  patients,
  (patients) => Array.from(
    new Set(patients.map(x => x.recordStatus))
  ).filter(x => !!x).sort()
);

export const activeTab = createSelector(
  state => state.sample.uiState,
  state => state.activeTab
);



// WEBPACK FOOTER //
// ./src/modules/sample/sample.selectors.js